import { FuelType, VehicleExtensions } from '../../../../interfaces/vehicle';
import { TelemetryVehicle, VehicleWithTelemetry } from '../../../../interfaces/telemetry';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Vehicle } from '../../../../interfaces/vehicle';
import { DateRangeService, DateRageValue, DateRangeValueType } from '../../../../shared/modules/date-range-filter/date-range.service';
import { TelemetryService } from '../../../../core/services/telemetry.service';
import { debounceTime, map, switchMap, tap, distinctUntilChanged } from 'rxjs/operators';
import { PerspectiveMenuService } from '../../../../shared/modules/perspective-menu/perspective-menu.service';
import { arrayValueFilter, arrayValueFilterByRange } from 'src/app/utils/array-value-filter';
import { DatePipe } from '@angular/common';
import { getAnalogFuelPercentage } from 'src/app/utils/fuel-analog';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MapService } from 'src/app/shared/modules/map/map.service';

interface IChartFilter {
  propertyName: string[];
  axisDimmension: string;
}

interface ISensorProperty {
  propertyName: string;
  name: string;
  noDataValue?: number;
  multiplier?: number;
}


@Component({
  selector: 'app-vehicle-map',
  templateUrl: './vehicle-map.component.html',
  styleUrls: ['./vehicle-map.component.scss'],
  providers: [DatePipe, MapService]
})
export class VehicleMapComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  public vehicle: VehicleWithTelemetry;

  public pending = true;
  public items: VehicleWithTelemetry[] = [];
  constructor(private route: ActivatedRoute,
              public mapService: MapService) {
  }

  ngOnInit(): void {
    this.buildForms();
    this.subscription.add(this.route.parent.data.subscribe(({vehicle}) => {
      this.vehicle = vehicle;
      this.items = [vehicle];
      this.centerMap();
    }));
    this.subscription.add(this.mapService.mapIsLoad.subscribe(() => {
      if (this.vehicle?.telemetry?.position !== null) {
        this.centerMap();
        this.mapService.mapInstance.setZoom(15, false);
      }
    }));
  }

  buildForms(): void {
   
  }

  centerMap() {
    if (this.vehicle && this.vehicle.telemetry && this.vehicle.telemetry.position && 
      this.vehicle?.telemetry?.position?.coordinates !== null && this.mapService.mapInstance) {
      this.mapService.mapInstance.setCenter({
        lat: this.vehicle.telemetry.position.coordinates[1],
        lng: this.vehicle.telemetry.position.coordinates[0],
      }, true);
    }
  }

  
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
